exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".antv-chart-mini[data-v-2f95bc45] {\n  position: relative;\n  width: 100%;\n}\n.antv-chart-mini .chart-wrapper[data-v-2f95bc45] {\n  position: absolute;\n  bottom: -28px;\n  width: 100%;\n  /*    margin: 0 -5px;\n    overflow: hidden;*/\n}\n", ""]);

// exports
